
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { fetchCashiersByBranch } from "../../../../../services/Settings/Cashier";
import LinkCashierDialog from "./LinkCashierDialog";
import UnlinkCashierDialog from "./UnlinkCashierDialog";

const CashiersListByBranch = ({ rootId, userId, onSuccess }) => {
  const [cashiers, setCashiers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCashierToLink, setSelectedCashierToLink] = useState(null);
  const [selectedCashierToUnlink, setSelectedCashierToUnlink] = useState(null);

  useEffect(() => {
    const loadCashiers = async () => {
      try {
        const data = await fetchCashiersByBranch(rootId);
        setCashiers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (rootId) loadCashiers();
  }, [rootId]);

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <Box>
      
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>الاسم</TableCell>
              <TableCell>الفرع</TableCell>
              <TableCell>الطابعة</TableCell>
              <TableCell>الحالة</TableCell>
              <TableCell>إجراء</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cashiers
              .filter((cashier) => cashier.status === 1)
              .map((cashier) => (
                <TableRow key={cashier.id}>
                  <TableCell>{cashier.name}</TableCell>
                  <TableCell>{cashier.root_name}</TableCell>
                  <TableCell>{cashier.printer_name}</TableCell>
                  <TableCell>✅ مفعل</TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      onClick={() => setSelectedCashierToLink(cashier)}
                    >
                      <LinkIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => setSelectedCashierToUnlink(cashier)}
                    >
                      <LinkOffIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedCashierToLink && (
        <Dialog open={true} onClose={() => setSelectedCashierToLink(null)}>
          <LinkCashierDialog
            userId={userId}
            cashier={selectedCashierToLink}
            onClose={() => setSelectedCashierToLink(null)}
            onSuccess={() => {
              setSelectedCashierToLink(null);
              if (onSuccess) onSuccess();
            }}
          />
        </Dialog>
      )}

      {selectedCashierToUnlink && (
        <Dialog open={true} onClose={() => setSelectedCashierToUnlink(null)}>
          <UnlinkCashierDialog
            userId={userId}
            cashier={selectedCashierToUnlink}
            onClose={() => setSelectedCashierToUnlink(null)}
            onSuccess={() => {
              setSelectedCashierToUnlink(null);
              if (onSuccess) onSuccess();
            }}
          />
        </Dialog>
      )}
    </Box>
  );
};

export default CashiersListByBranch;
